/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by maximeallex on 2018-04-11.
 */


'use strict';
import { Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {Tools} from "linkurious-shared";

@Injectable()
export class LKContextMenuService {

  public event$: Subject<ContextMenuEvent|CloseMenuEvent|LoadingMenuEvent> = new Subject();
  private _menuIsFetched: Array<string> = [];

  /**
   * Open the context menu through the cursor position
   */
  public openOnCursor(configuration: {
    menu: Type<any>;
    props?: {[key: string]: Promise<any>};
    width: number;
    height: number;
    curtain?: boolean;
    cursor: {x: number, y: number};
  }) {
    this.event$.next(new LoadingMenuEvent(
      configuration.width,
      configuration.height,
      'relative',
      configuration.cursor
    ));
    this.getProperties(configuration.props || {}, `${configuration.cursor.x}${configuration.cursor.y}`).then(result => {
      if ( this._menuIsFetched.length > 0 && this._menuIsFetched[this._menuIsFetched.length - 1] === `${configuration.cursor.x}${configuration.cursor.y}` ) {
        this._menuIsFetched = [];
        this.event$.next(new ContextMenuEvent(
          undefined,
          configuration.menu,
          result,
          undefined,
          configuration.cursor,
          configuration.width,
          configuration.height,
          configuration.curtain,
          false,
          false,
          false,
          'relative'
        ));
      } else {
        this._menuIsFetched.splice(this._menuIsFetched.findIndex(i => i === `${configuration.cursor.x}${configuration.cursor.y}`), 1);
      }
    });
  }

  private getProperties(props: any, menuId: string): Promise<any> {
    this._menuIsFetched.push(menuId);
    if ( Tools.isDefined(props) ) {
      let promises = [];
      Object.keys(props).forEach(key => {
        promises.push(props[key]);
      });

      return Promise.all(promises).then(results => {
        let result = {};
        Object.keys(props).forEach(( key, index ) => {
          result[key] = results[index];
        });
        return result;
      }).catch((e) => {
        return Promise.reject(e);
      });
    } else {
      return Promise.resolve({});
    }
  }

  /**
   * Open the context menu
   */
  public open(
    menu: Type<any>,
    event: MouseEvent,
    props: {[key: string]: any} = {},
    width: number,
    height: number,
    curtain: boolean,
    arrow: boolean,
    cross: boolean,
    disallowClose: boolean,
    trigger: HTMLElement,
    position: 'top'|'bottom'|'left'|'right'|'relative'
  ) {
    this.event$.next(new LoadingMenuEvent(width, height, position, undefined, trigger));
    this.getProperties(props, `${event.x}${event.y}`).then((result) => {
      if ( this._menuIsFetched.length > 0 && this._menuIsFetched[this._menuIsFetched.length - 1] === `${event.x}${event.y}` ) {
        this._menuIsFetched = [];
        this.event$.next(new ContextMenuEvent(
          event,
          menu,
          result,
          trigger,
          undefined,
          width,
          height,
          curtain,
          arrow,
          cross,
          disallowClose,
          position
        ));
      } else {
        this._menuIsFetched.splice(this._menuIsFetched.findIndex(i => i === `${event.x}${event.y}`), 1);
      }
    });
  }
  /**
   * Close the context menu
   */
  public close(): void {
    this.event$.next(new CloseMenuEvent());
  }
}

export class ContextMenuEvent {
  public event: MouseEvent;
  public menu: Type<any>;
  public props: {[key: string]: any};
  public trigger: HTMLElement;
  public cursorPosition: {x: number; y: number};
  public width: number;
  public height: number;
  public curtain: boolean;
  public arrow: boolean;
  public cross: boolean;
  public disallowClose: boolean;
  public position: 'top'|'bottom'|'left'|'right'|'relative';

  constructor(
    event: MouseEvent,
    menu: Type<any>,
    props: {[key: string]: any},
    trigger: HTMLElement,
    cursorPosition: {x: number; y: number},
    width: number,
    height: number,
    curtain: boolean,
    arrow: boolean,
    cross: boolean,
    disallowClose: boolean,
    position: 'top'|'bottom'|'left'|'right'|'relative'
  ) {
    this.event = event;
    this.menu = menu;
    this.props = props;
    this.trigger = trigger;
    this.cursorPosition = cursorPosition;
    this.disallowClose = disallowClose;
    this.width = width;
    this.height = height;
    this.curtain = Tools.isDefined(curtain) ? curtain : true;
    this.arrow = arrow;
    this.cross = cross;
    this.position = position;
  }
}

export class CloseMenuEvent {}

export class LoadingMenuEvent {
  public width: number;
  public height: number;
  public position: 'top'|'bottom'|'left'|'right'|'relative';
  public cursorPosition: {x: number; y: number};
  public trigger: HTMLElement;

  constructor(
    width: number,
    height: number,
    position: 'top'|'bottom'|'left'|'right'|'relative',
    cursorPosition?: {x: number; y: number},
    trigger?: HTMLElement
  ) {
    this.width = width;
    this.height = height;
    this.position = position;
    this.cursorPosition = cursorPosition;
    this.trigger = trigger;
  }
}
